import React from "react";
import { ApiPackagingSummary } from "../../../../../types/prodcut-data-review/product-data.types";
import PackagingLevelTable from "./PackagingLevelTable";
import { usePackagingDetail } from "../hooks/usePackagingDetail";
import { usePackagingMaterialCrud } from "../hooks/usePackagingMaterialCrud";
import { usePackagingUnitCrud } from "../hooks/usePackagingUnitCrud";
import { GateKind } from "../types/packagingDetail.types";

interface PackagingDetailPanelProps {
  packaging: ApiPackagingSummary;
  gateId: string;
  gateKind: GateKind;
  disabled?: boolean;
}

export const PackagingDetailPanel: React.FC<PackagingDetailPanelProps> = ({
  packaging,
  gateId,
  gateKind,
  disabled = false
}) => {
  const { levels, unitSnapshot, isLoading, isError, refetch } = usePackagingDetail({
    packagingId: packaging._id,
    gateKind,
    enabled: true
  });

  const { addMaterial, updateMaterial, removeMaterial } = usePackagingMaterialCrud({
    packagingId: packaging._id,
    gateId,
    gateKind,
    onSaved: refetch
  });

  const { saveUnitField } = usePackagingUnitCrud({
    packagingId: packaging._id,
    gateId,
    gateKind,
    unitSnapshot,
    onSaved: refetch
  });

  if (isLoading) {
    return <div className="tw-text-xs tw-text-muted-foreground tw-py-3 tw-px-1">Loading packaging details…</div>;
  }

  if (isError) {
    return <div className="tw-text-xs tw-text-destructive tw-py-3 tw-px-1">Failed to load packaging details.</div>;
  }

  return (
    <PackagingLevelTable
      levels={levels}
      onAddMaterial={addMaterial}
      onUpdateMaterial={(level, materialId, values) => {
        const current = levels.find(l => l.apiType === level)?.materials.find(m => m.id === materialId);
        if (!current) return;
        updateMaterial(level, materialId, values, current);
      }}
      onRemoveMaterial={removeMaterial}
      onSaveUnit={saveUnitField}
      disabled={disabled}
    />
  );
};

export default PackagingDetailPanel;
